import { useContext, useEffect } from "react";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Button } from "@ecco/ui/button";
import { Controller, MapState } from "./controller";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { focusOutline } from "@ecco/ui/css/focus";
import type { StoreData } from "@features/stores/types";
import type { JSX } from "react";

export const Capture = ({ searchResults }: { searchResults?: StoreData[] }): JSX.Element => {
    const { get: getMicrocopy } = useMicrocopy();
    const {
        setStoreData,
        setMapState,
        clientLocation,
        setFilterDistance,
        filterDistance,
        setCurrentLocation,
    } = useContext(Controller);

    const handleCapture = () => {
        setCurrentLocation();
        if (filterDistance) setFilterDistance(null);
    };

    useEffect(() => {
        if (searchResults) {
            setStoreData(searchResults);
            setFilterDistance(null);
            setMapState(MapState.Ready);
        }
    }, [clientLocation, searchResults]);

    return (
        <Button
            h="initial"
            ml={1}
            variant="link"
            textDecoration="none"
            fontWeight="bold"
            justifyContent="flex-start"
            _focusVisible={focusOutline}
            onClick={handleCapture}
            leftIcon={<ECCOIcon name="store-locator" />}
        >
            <span>{getMicrocopy("page", "storeLocator.captureLocation")}</span>
        </Button>
    );
};
